const userDashboardHomeDictPT = {
  bonus: "Renda diária",
  balance: "Saldo",
  inbound: "Crédito",
  outbound: "Débito",
  every: "A cada ",
  AmountIsAutomaticallyTransferredToWallet:
    " o valor é transferido automaticamente para a carteira principal.",
  currentlyYouCan: "Atualmente você pode utilizar até ",
  ofYourExtracoin: " do seu saldo Extracredit para pagar suas compras.",
  extracoinOnlyBetweenUsers:
    "O Extracredit é somente para compras e transferências entre usuários!",
  indirects: "Indiretos",
  stats: "Estatísticas",
  plan: "Plano",
  subscription: "Assinatura",
  daysLeft: " dias restantes",
  activation: "Ativação",
  seeAllDirects: "Ver todos os diretos",
  youDontHaveAny: "Você não tem nenhum usuário direto na seu Círculo Econômico ainda",
  days: "dias",
  months: "meses",
  year: "ano",
  numberOfUsersInNetwork: "Número de usuários adicionados à seu Círculo Econômico",
  date: "Data",
  monthNames: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
  quantity: "Quantidade",
  referralLinks: "Links de referimento",
  shareReferrals: "Compartilhe indicações",
  share: "Compartilhar",
  copy: "Copiar",
  copiedToClipboard: "Copiado para a área de transferência.",
  copied: "Copiado",
  notActive: "Usuário Inativo",
  balanceCommission: "comissões",
  balanceSale: "vendas",
  message: "Mensagem",
  imAware: "Estou ciente",
  alert: "Alerta",
  notEnabled:
    "Sua conta não pode enviar produtos no momento. Edite o endereço do seu perfil para um endereço válido.",
  inAnalysis: "Seu endereço de coleta de pacotes fornecido está sendo analisado.",
  enabled: "Seu endereço de coleta de pacotes fornecido está apto para enviar produtos.",
  thisIsPickupAddress:
    "Este endereço será usado pelas empresas de transporte para retirar seus pacotes",
  renewSubscriptionValue: "Valor para renovar sua assinatura",
  referralLinksExplanation:
    "Use estes links para cadastrar novos usuários nos vários planos e aumentar automaticamente seu círculo econômico ganhando comissões e rendas diárias de acordo com nosso plano de compensação.",
  profile: "Perfil",
  activationRequirements: "Para a ativação é necessário 1 cadastro ou 1 compra por mês.",
  safePayment: "Pagamento seguro",
  balanceForExternalAds: "Saldo para anúncios externos",
  youCanUseThisAmountToMakeExternalAds:
    "Você pode utilizar este saldo para fazer anúncios externos",
  transaction: "Transação",
  transactions: "Transações",
  create: "Criar",
  qrCodeOfTransaction: "Qr Code da transação",
  paymentDate: "Data de pagamento",
  payWithExtracredit: "Pagar com Extracredit",
  payWithWallet: "Pagar com carteira",
  sumOfValuesIsDifferent: "A soma dos valores é diferente do valor da transação",
  transactionDone: "Transação realizada com sucesso!",
  to: "Para",
  awaitingPayment: "Aguardando pagamento",
  payer: "Pagador",
  idOfTransaction: "Id da Transação",
  makeAnotherPayment: "Fazer outro pagamento",
  qrcodereferralLinks: "Qr Code do link de referimento",
  economicCircle: "Círculo econômico",
  yourNetworkOfInfluence: "Sua rede de influência",
  close: "Fechar",
  members: "Membros",
  viewNetwork: "Ver rede",
  networkCommissionLabel: "Comissão de rede",
  dailyIncomeLabel: "Renda diária",
  networkReferralCommissionLabel: "Comissão por indicação",
  networkReferralCommissionInfo: "Comissões recebidas quando pessoas da sua rede (indicados diretos e indiretos) compram um plano. Não inclui a sua receita própria.",
  networkSalesCommissionLabel: "Comissão por vendas",
  networkSalesCommissionInfo: "Comissões recebidas sobre compras, vendas e transferências feitas por pessoas da sua rede. Não inclui o que você ganha com as suas próprias vendas.",
  roleCustomer: "Customer",
  rolePromoter: "Promoter",
  roleManager: "Manager",
  roleManagerAssociation: "Manager Association",
  rolePartner: "Partner",
  roleSeller: "Seller",
  roleStore: "Store",
  doTheDiagnosis: "Participe da Avaliação",
  associationConfimeaShareTitle: "Link Business Square",
  associationConfimeaShareDescription:
    "Compartilhe este link para que novos Managers se cadastrem usando o documento da sua associação.",
};

export default userDashboardHomeDictPT;
